<div class="HeaderContainer flex-row flex-between flex-middle">
    <ng-content></ng-content>
</div>
